// @flow strict

import { createContext } from 'react';

export default createContext<(string => void)>(() => {});
